import { get } from './apiService';

/**
 * Get all roles
 * @returns {Promise<Array>} List of roles
 */
export async function getRoles() {
  return await get('/roles');
}

